import $ from 'jquery';
import { initContainers } from './init';
import { updateLinkState } from './utilities';
import { AjaxLoader, isLocalLink, getBody } from './ajax_util';
import { isMobileSite } from './constants';
import { addHandler } from './scroll_resize';

// TODO work out how to import a jquery plugin es6 style
window.jQuery = $;
require('../lib/jquery.formstyles.js');

function commonInit(containers) {
  containers.find('input:radio').checkboxstyles();
  containers.find('input:checkbox').checkboxstyles();
}

function isAltContent(article) {
  return article.is(
    '.applications-index, .trust, .static-page, .warrentrust-scholarships');
}

function loadDefaultAltContent(callback) {
  $.get($('#header nav a').eq(0).attr('href'), (html) => {
    $('#alt-content').html(getBody(html).find('#content').html());
    initContainers($('#alt-content > article'));
    callback();
  });
}

function normaliseContent(callback) {
  // rearrange content for desktop/mobile
  // see also loadNewContent

  if (!callback) {
    callback = () => { };
  }

  if (isMobileSite()) {
    var altContent = $('#alt-content > article');
    if (altContent.length) {
      $('#content').html('').append(altContent);
      $('#alt-content').html('');
      callback();
    }
  } else {
    var content = $('#content > article');
    if (isAltContent(content)) {
      $('#alt-content').html('').append(content);
      // reinstate home content
      $.get('/', (html) => {
        $('#content').html(getBody(html).find('#content').html());
        initContainers($('#content > article'));
        callback();
      });
    } else if (window.location.pathname === '/') {
      // load default page into alt-content if it's empty
      loadDefaultAltContent(callback);
    } else {
      callback();
    }
  }
}

function loadNewContent(newContent, callback) {
  // load new downloaded content
  // see also normaliseContent

  var newHeading = newContent.find('#header .site-heading-wrap');
  if (newHeading.find('.heading404').length) {
    $('#header .site-heading-wrap').html(newHeading.html());
    callback();
    return;
  }

  function defaultLoad() {
    $('#content').html('').append(newContent);
    $('#content-wrap').animate({ scrollTop: 0 }, 500);
  }

  if (isMobileSite()) {
    defaultLoad();
  } else if (newContent.is('.projects-project')) {
    // load in overlay above right hand col
    overlay(newContent);
    $('#overlay').scrollTop(0);
  } else if (isAltContent(newContent)) {
    // load in below header
    $('#alt-content').html('').append(newContent);
    $('#header-wrap').animate({
      scrollTop: $('#header').outerHeight(true)
    }, 500);
    overlay(false);
  } else {
    defaultLoad();
    overlay(false);
    if (window.location.pathname === '/') {
      // load default page into alt-content if it's empty
      loadDefaultAltContent(callback);
      $('#header-wrap').animate({
        scrollTop: 0
      }, 500);
    } else {
      callback();
    }
  }

  callback();
}

var overlayInitialised = false;
var overlayVisible = false;
function overlay(content) {
  var el = $('#overlay');

  // close on overlay click
  if (!overlayInitialised) {
    el.find('#overlay-outer').on('click', (e) => {
      if ($(e.target).is('#overlay-outer')) {
        el.find('.close').trigger('click');
      }
    });
    overlayInitialised = true;
  }

  if (content) {
    el.find('#overlay-inner').html('').append(content);
    $('html').addClass('state-overlay');
    overlayVisible = true;
  } else {
    $('html').removeClass('state-overlay');
    overlayVisible = false;
  }
}

function setup() {
  commonInit($('#header'));

  $(document).on('keydown', (e) => {
    if (e.which === 27 && overlayVisible) {
      overlay(false);
      e.preventDefault();
    }
    // else if (e.which === 37) {
    //   // prev
    // } else if (e.which === 39) {
    //   // next
    // }
  });
  $('#overlay').on('click', (e) => {
    if ($(e.target).is('#overlay')) {
      overlay(false);
    }
  });

  addHandler({
    resize: () => {
      normaliseContent(() => {
        // sb.initialize();
      });
    }
  }, true);

  var ajax = new AjaxLoader('site', (newBody) => {
    var newContent = newBody.find('#content > article');

    loadNewContent(newContent, () => {
      initGlobal();
      initContent();
    });
  }, {
    onBeforeLoad: (url) => {
      const contentUrl = $('#content > article').data('content_url');
      const altUrl = $('#alt-content > article').data('content_url');
      if ($('html').is('.state-overlay') &&
        (contentUrl === url || altUrl === url)) {
        // just hide the overlay if that option is available
        overlay(false);
        return false;
      }
    }
    // ajaxUrl: (url) => {},
    // onStateChange: () => {}
  });

  function isAjax() {
    return !$('body').is('.p404') && !isMobileSite();
  }

  // handle all link clicks here
  $('body').on('click', 'a', function (e) {
    var modifier = e.shiftKey || e.ctrlKey || e.metaKey;
    var link = $(this);

    if (modifier || !isAjax() || !isLocalLink(link)) {
      return;
    }

    // if (link.is('#overlay .close')) {
    //   // assume we can just go back to reveal the content underneath
    //   window.history.back();
    // } else {
    //   ajax.load(link.attr('href'));
    // }
    ajax.load(link.attr('href'));
    e.preventDefault();
  });

  // $('#burger').on('click', () => {
  //   $('html').toggleClass('state-burger');
  // });
}

function initGlobal() {
  // runs every time the window location changes
  updateLinkState($('#header, #footer'));
}

function initContent() {
  // initialises newly loaded content
  var current = $('#content > article, #alt-content > article');
  initContainers(current);
  commonInit(current);
  updateLinkState(current);
}

$(() => {
  setup();
  initGlobal();
  initContent();

  $('body').removeClass('doc-loading').addClass('loaded');
});

$(window).on('load', () => {
  $('body').removeClass('loading');
  $('html').removeClass('no-js');
});



// WEBPACK FOOTER //
// ./assets/j/src/site.js